import {
  type OccasionPreferenceDietaryRestrictions,
  type DietaryRestriction,
} from '@hungryroot/rest';

const PRIMARY_DIETARY_RESTRICTIONS = new Set([
  'is_omnivore',
  'is_flexitarian',
  'is_pescatarian',
  'is_vegetarian',
  'is_vegan',
]);

export function getOccasionPreferenceDietaryRestrictionParamFromDietaryRestrictions(
  dietaryRestrictions: DietaryRestriction[]
) {
  const primaryDietaryRestriction = dietaryRestrictions.find(
    (dietaryRestriction) =>
      dietaryRestriction.selected &&
      PRIMARY_DIETARY_RESTRICTIONS.has(dietaryRestriction.field_name)
  );

  const dairyFree = dietaryRestrictions.find(
    (dietaryRestriction) =>
      dietaryRestriction.selected &&
      dietaryRestriction.field_name === 'is_dairy_free'
  );

  const dietaryRestrictionParam =
    primaryDietaryRestriction?.field_name === 'is_omnivore' &&
    dairyFree !== undefined
      ? `${primaryDietaryRestriction.field_name},${dairyFree.field_name}`
      : primaryDietaryRestriction?.field_name;

  return dietaryRestrictionParam as
    | OccasionPreferenceDietaryRestrictions
    | undefined;
}
